<!-- (click)="isMobileVerification = true; userStateService.isInvalidState = true;" -->
<!-- <div class="modal__description m-b-xs-medium m-b-lg-regular font-xs-regular font-lg-medium-big font-color-gray font-weight-bold">
    Enter the information below to view loan offers through iCreditWorks
</div> -->
<div class="modal__main">
    <div class="main__leftpart">
        <div class="leftpart__image leftpart__image_big">
            <img [src]="sharedDataService.assetsCdn('images/dent-and-pony.jpg')" alt="" loading="lazy" />
        </div>
    </div>

    <div class="main__rightpart p-x-xs-small main__rightpart_col max-width-60" [style.z-index]="!isWelcomeBack && !isHawaiiMessage ? '2' : 'initial'" [style.position]="!isWelcomeBack && !isHawaiiMessage ? 'relative' : 'initial'"  [ngClass]="{
      'welcome-back-mobile-shadow': isWelcomeBack || isHawaiiMessage,
      is_session_shadow: isSessionTimeout,
      'is-mobile-validation': isMobileVerification
    }">
        <app-invalid-state-popup [hidden]="isHawaiiMessage" style="z-index: 500; width: 100%" (toggleLoader)="toggleLoaderEvent($event)" [ngStyle]="{ position: breakpoints.extraSmall ? 'relative' : 'inherit' }" *ngIf="((userStateService.isInvalidState || userStateService.isInvalidStateAmount) && !isMobileVerification) || blockedError"
            [type]="userStateService.type" [isBlocked]="blockedError" [isMobile]="breakpoints.extraSmall"></app-invalid-state-popup>
        <app-welcome-back-popup style="z-index: 500" *ngIf="isWelcomeBack && breakpoints.extraSmall" [isMobile]="breakpoints.extraSmall" [withContinue]="isWelcomeBackContinue" [lassSession]="lastSessionDate" (closed)="onWelcomeBackPopupClosed()"></app-welcome-back-popup>
        <app-hawaii-message-popup style="z-index: 501" *ngIf="isHawaiiMessage && breakpoints.extraSmall" [isMobile]="breakpoints.extraSmall" (closed)="onHawaiiMessagePopupClosed()"></app-hawaii-message-popup>
        <app-mobile-validation-popup style="z-index: 500; position: relative" *ngIf="isMobileVerification" [isMobile]="breakpoints.extraSmall" (closed)="onMobileValidationPopupClosed()"></app-mobile-validation-popup>
        <app-session-timeout-popup style="z-index: 500" *ngIf="isSessionTimeout && breakpoints.extraSmall" [isMobile]="breakpoints.extraSmall" (toClose)="onSessionPopupToClose()" (toContinue)="onSessionPopupContinue()"></app-session-timeout-popup>
        <!-- <app-modal-options-dentist-select style="z-index: 500" *ngIf="isSessionTimeout && breakpoints.extraSmall"></app-modal-options-dentist-select> -->
        <!-- <div *ngIf="!isHawaiiMessage && !isWelcomeBack && !isSessionTimeout" class="header-xs-small header-lg-extra-small font-color-dark-gray font-weight-bold">
            Checking your options won’t affect your credit score.
        </div> -->
     
     
 <!--     
        <div *ngIf="!isHawaiiMessage && !isWelcomeBack && !isSessionTimeout" class="header-xs-small header-lg-extra-small font-color-dark-gray font-weight-bold">
            How much do you need?
        </div>
        <div *ngIf="!isHawaiiMessage && !isWelcomeBack && !isSessionTimeout" class="topCheckOpt d-flex a-items-center font-xs-small font-lg-regular m-b-xs-regular m-b-lg-medium" style="position: relative">
            <span *ngIf="!isHawaiiMessage && !isWelcomeBack && !isSessionTimeout">
        Checking your options won’t affect your credit score.</span
      >
 -->
<div>


      <!-- (mouseenter)="onInfoIconTrigger(true, $event)" (mouseleave)="onInfoIconTrigger(false, $event)"  -->
      <!-- <span
        class="icon icon_small icon_gray icon_info-orange"
        (click)="onInfoIconTrigger(!showHooverMenu, $event)"
      >
      </span> -->
            <app-hoover-popup [isMobile]="breakpoints.extraSmall" [text]="hooverPopupText" [type]="'modal'" [additionalClasses]="'wide align-bottom-center font-weight-bold hooverPopupPositionA'" class="hover-content" (closed)="onClosed($event)" *ngIf="showHooverMenu">
            </app-hoover-popup>
        </div>



        <app-welcome-back-popup style="z-index: 500; position: absolute" *ngIf="isWelcomeBack && !breakpoints.extraSmall" [withContinue]="isWelcomeBackContinue" [multiLoan]="isMultiLoan" [lassSession]="lastSessionDate" [isMobile]="breakpoints.extraSmall" (closed)="onWelcomeBackPopupClosed()"></app-welcome-back-popup>
        <app-hawaii-message-popup style="z-index: 501; position: absolute" *ngIf="isHawaiiMessage && !breakpoints.extraSmall" [isMobile]="breakpoints.extraSmall" (closed)="onHawaiiMessagePopupClosed()"></app-hawaii-message-popup>
        <app-session-timeout-popup style="z-index: 500; position: absolute" *ngIf="isSessionTimeout && !breakpoints.extraSmall" [isMobile]="breakpoints.extraSmall" (toClose)="onSessionPopupToClose()" (toContinue)="onSessionPopupContinue()"></app-session-timeout-popup>
        
        
<!--             <web-prequal-options-get-phonenumber
                [isWebAppGetPhoneNumber]="isWebAppGetPhoneNumber"
                *ngIf="!isWelcomeBack &&  breakpoints.extraSmall && isWebAppGetPhoneNumber" 
                (letsGetPhoneNumberSubmit)="letsGetPhoneNumberSubmitEvent($event)" >
              </web-prequal-options-get-phonenumber> -->

           <web-prequal-options-qr-code 
            [ngStyle]="{ 'width': '100%', 'height' : '100%'}"
            *ngIf="!isWelcomeBack &&  (!breakpoints.extraSmall || !breakpoints.small)"
            >
            </web-prequal-options-qr-code> 
        
<!--         <app-modal-options-form (showErrorPopupType)="showErrorPopup($event)" (toggleLoader)="toggleLoaderEvent($event)" (showPopup)="showFormPopup()" [hidden]="isHawaiiMessage" *ngIf="!isWelcomeBack" [ngStyle]="{
        visibility: isSessionTimeout ? 'collapse' : 'visible',
        height: isSessionTimeout ? '0px' : 'inherit'
      }" (runSessionTimer)="isSessionTimeout = true" [layout]="'mainform'" [isBlocked]="blockedError" [FULL_DEV]="FULL_DEV" [breakpoints]="breakpoints" (dataSubmited)="onSubmit($event)" style="width: 100%"></app-modal-options-form>
 -->

      <div class="loader__wrapper" *ngIf="showLoader">
        <div class="loader"></div>
        </div>
    </div>
</div>